export default __webpack_public_path__ + "static/media/gs8-applicant-user-flow.0c5808e3.jpg";